var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',[_c('a',{on:{"click":_vm.goHome}},[_vm._v("汉江博客")])]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]),_c('div',{staticClass:"clear"})])}
var staticRenderFns = []

export { render, staticRenderFns }